<ng-template #valueCell let-source="source" let-row="row">
  <td class="value-cell">
    {{ snapshotValue(source, row.key) ?? '-' }}
    <span
      class="as-date"
      *ngIf="row.isTimestamp && snapshotValue(source, row.key)"
    >
      {{
        $any(snapshotValue(source, row.key))
          | date : timestampFormat : timestampTz
      }}
      UTC
    </span>
  </td>
</ng-template>

<ng-template #snapshotTable let-groups="groups" let-grouped="grouped">
  <div class="table-scroll">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Field</th>
          <th scope="col">Before</th>
          <th scope="col" *ngIf="surveyAfter">After</th>
        </tr>
      </thead>

      <tbody *ngFor="let group of groups">
        <tr class="group-row" *ngIf="grouped">
          <td [attr.colspan]="surveyAfter ? 3 : 2">
            <button
              type="button"
              class="group-toggle"
              [attr.aria-expanded]="isGroupOpen(group.key)"
              (click)="toggleGroup(group.key)"
            >
              <span
                class="caret"
                [class.caret--closed]="!isGroupOpen(group.key)"
                >&#9660;</span
              >
              {{ group.title }}
              <span class="group-count">{{ group.rows.length }} fields</span>
            </button>
          </td>
        </tr>

        <ng-container *ngIf="!grouped || isGroupOpen(group.key)">
          <tr *ngFor="let row of group.rows" [ngClass]="changedClass(row)">
            <td>{{ row.label }}</td>
            <ng-container
              *ngTemplateOutlet="
                valueCell;
                context: { source: surveyBefore, row: row }
              "
            ></ng-container>
            <ng-container
              *ngIf="surveyAfter"
              [ngTemplateOutlet]="valueCell"
              [ngTemplateOutletContext]="{ source: surveyAfter, row: row }"
            ></ng-container>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>

<main class="feot-pacing-tool">
  <header class="tool-header">
    <div class="tool-header__identity">
      <h2 class="header-text">FEOT Pacing Tool</h2>

      <div class="chips" *ngIf="surveyBefore">
        <span class="survey-name" *ngIf="surveyBefore.title">{{
          surveyBefore.title
        }}</span>
        <span class="chip chip--code">#{{ surveyBefore.surveyId }}</span>
        <span class="chip chip--code">{{ surveyBefore.env }}</span>
        <span
          class="chip"
          [ngClass]="surveyBefore.isSimulationTarget ? 'chip--on' : 'chip--off'"
          >st {{ surveyBefore.st }}</span
        >
        <span
          class="chip"
          [ngClass]="surveyBefore.feot.enabled ? 'chip--on' : 'chip--off'"
          >FEOT {{ surveyBefore.feot.enabled ? 'on' : 'off' }}</span
        >
        <span class="chip chip--info" *ngIf="surveyBefore.feot.is_midway_survey"
          >Midway</span
        >
      </div>
    </div>

    <div class="tool-header__actions">
      <button
        type="button"
        class="ghost-button"
        (click)="refreshSurvey()"
        [disabled]="surveyLoading || !surveyBefore"
      >
        Refresh
      </button>
      <button
        type="button"
        psUiButton
        [outline]="true"
        (click)="patchFeotClock()"
        [disabled]="!form || form.invalid || submitted"
      >
        Update FEOT Clock
      </button>
    </div>
  </header>

  <div class="tool-grid">
    <!-- ============ action panel ============ -->
    <aside class="panel action-panel">
      <div class="panel__head">
        <h3>Action panel</h3>
      </div>

      <form
        class="panel__body"
        [formGroup]="form"
        (ngSubmit)="patchFeotClock()"
        *ngIf="form"
      >
        <div class="field">
          <label class="field-label" for="surveyId">Survey id</label>
          <input
            type="number"
            class="form-control survey-id"
            id="surveyId"
            placeholder="Survey id"
            formControlName="surveyId"
          />
          <small class="field-hint">{{ copy.surveyIdHint }}</small>
        </div>

        <hr />

        <div class="field-label">Field time already elapsed</div>

        <div
          *ngFor="let mode of modes"
          class="mode-row"
          [class.mode-row--selected]="form.controls.mode.value === mode.key"
        >
          <label class="mode-option">
            <input type="radio" formControlName="mode" [value]="mode.key" />
            <span class="mode-label">{{ mode.label }}</span>
          </label>

          <select
            *ngIf="mode.key === 'elapsed'"
            class="form-control"
            formControlName="elapsed"
          >
            <option
              *ngFor="let elapsedOption of elapsedOptions"
              [value]="elapsedOption.value"
            >
              {{ elapsedOption.label }}
            </option>
          </select>

          <ng-container *ngIf="mode.key === 'elapsedHours'">
            <input
              type="number"
              class="form-control"
              min="0"
              placeholder="Elapsed time"
              formControlName="elapsedHours"
            />

            <div class="unit-options">
              <label
                class="unit-option"
                *ngFor="let unit of elapsedUnits"
                [class.unit-option--on]="
                  form.controls.elapsedUnit.value === unit.value
                "
              >
                <input
                  type="radio"
                  formControlName="elapsedUnit"
                  [value]="unit.value"
                />
                <span>{{ unit.label }}</span>
              </label>
            </div>

            <small
              class="field-hint field-hint--mono"
              *ngIf="convertedElapsedHours !== null"
            >
              Sends elapsedHours: {{ convertedElapsedHours }}
            </small>
          </ng-container>

          <input
            *ngIf="mode.key === 'surveyLaunchTS'"
            type="number"
            class="form-control"
            placeholder="Unix milliseconds"
            formControlName="surveyLaunchTS"
          />

          <small
            class="field-hint field-hint--mono"
            *ngIf="
              mode.key === 'surveyLaunchTS' && surveyLaunchTSPreview !== null
            "
          >
            {{ surveyLaunchTSPreview | date : timestampFormat : timestampTz }}
            UTC
          </small>

          <small class="field-hint">{{ mode.hint }}</small>
        </div>

        <hr />

        <div class="field">
          <label class="checkbox-option">
            <input type="checkbox" formControlName="sendMidwayFlag" />
            <span>Send is_midway_survey</span>
          </label>

          <select
            *ngIf="isMidwayFlagSent"
            class="form-control value-select"
            formControlName="isMidwaySurvey"
          >
            <option [ngValue]="true">true</option>
            <option [ngValue]="false">false</option>
          </select>

          <small class="field-hint">{{ copy.midwayNotSent }}</small>
        </div>

        <div class="field">
          <label class="checkbox-option">
            <input type="checkbox" formControlName="trigger" />
            <span>Trigger an immediate recalculation</span>
          </label>
          <small class="field-hint">{{ copy.trigger }}</small>
        </div>

        <hr />

        <button
          class="submit-button"
          type="submit"
          psUiButton
          [outline]="true"
          [disabled]="form.invalid || submitted"
        >
          Update FEOT Clock
        </button>
      </form>
    </aside>

    <!-- ============ completes, pacing and survey state ============ -->
    <section class="tool-column">
      <div class="panel" *ngIf="currentSnapshot && hasCompletesData">
        <div class="panel__head">
          <h3>Completes</h3>
          <span class="panel__sub" *ngIf="currentSnapshot.buyer">
            {{ currentSnapshot.buyer.name || 'unnamed buyer' }} &middot; #{{
              currentSnapshot.buyer.id
            }}
          </span>
        </div>

        <div class="tiles">
          <div class="tile">
            <div class="tile__key">Fielded</div>
            <div class="tile__value">{{ completesFielded ?? '-' }}</div>
            <div class="tile__detail">
              {{
                completesPercent === null
                  ? 'goal not read'
                  : completesPercent + '% of goal'
              }}
            </div>
          </div>

          <div class="tile">
            <div class="tile__key">Goal</div>
            <div class="tile__value">{{ completesGoal ?? '-' }}</div>
            <div class="tile__detail">completes required</div>
          </div>

          <div class="tile">
            <div class="tile__key">Remaining</div>
            <div class="tile__value">{{ remainingGoal ?? '-' }}</div>
            <div class="tile__detail">goal &minus; fielded</div>
          </div>

          <div class="tile">
            <div class="tile__key">Midway</div>
            <div class="tile__value tile__value--word">
              <span [ngClass]="isMidwayEnabled ? 'flag-on' : 'flag-off'">{{
                isMidwayEnabled ? 'On' : 'Off'
              }}</span>
            </div>
            <div class="tile__detail">
              {{
                isMidwayEnabled
                  ? 'midway branch will run'
                  : 'standard branch will run'
              }}
            </div>
          </div>
        </div>

        <div class="field-window" *ngIf="completesPercent !== null">
          <div class="field-window__legend">
            <span class="field-window__lead">Collected</span>
            <span class="field-window__readout">
              {{ completesFielded }} / {{ completesGoal }}
            </span>
          </div>
          <div class="bar">
            <div class="bar__after" [style.width.%]="completesPercent"></div>
          </div>
        </div>

        <p class="panel__empty" *ngIf="!projectionInputs">
          {{ copy.projectionUnavailable }}
        </p>

        <ng-container *ngIf="projectionInputs">
          <div class="paths">
            <div
              class="path"
              [class.path--active]="!isMidwayEnabled"
              *ngIf="standardProjection as standard"
            >
              <div class="path__name">
                Standard path
                <span class="path__badge" *ngIf="!isMidwayEnabled">active</span>
              </div>
              <div class="path__figures">
                <div>
                  <span class="path__k">project current target</span>
                  <span class="path__v">{{ standard.projectTarget }}</span>
                </div>
                <div>
                  <span class="path__k">total currently open</span>
                  <span
                    class="path__v"
                    [class.path__v--idle]="standard.totalOpen === 0"
                    >{{ standard.totalOpen }}</span
                  >
                </div>
              </div>
              <p class="path__note">
                {{ copy.standardPathNote
                }}<ng-container *ngIf="standardFulfilledFieldTime !== null">
                  ({{ standardFulfilledFieldTime }} pacing units recorded,
                  against
                  {{ currentSnapshot?.fulfilledFieldTimeInPacingUnits }} of wall
                  clock since launch)</ng-container
                >.
              </p>
            </div>

            <div
              class="path"
              [class.path--active]="isMidwayEnabled"
              *ngIf="midwayProjection as midway"
            >
              <div class="path__name">
                Midway path
                <span class="path__badge" *ngIf="isMidwayEnabled">active</span>
              </div>
              <div class="path__figures">
                <div>
                  <span class="path__k">project current target</span>
                  <span class="path__v">{{ midway.projectTarget }}</span>
                </div>
                <div>
                  <span class="path__k">total currently open</span>
                  <span
                    class="path__v"
                    [class.path__v--idle]="midway.totalOpen === 0"
                    >{{ midway.totalOpen }}</span
                  >
                </div>
              </div>
              <p class="path__note">{{ copy.midwayPathNote }}</p>
            </div>
          </div>

          <div class="table-scroll" *ngIf="quotaComparison.length">
            <table class="table table--grouped">
              <thead>
                <tr>
                  <th scope="col" rowspan="2">Quota</th>
                  <th scope="col" rowspan="2">%</th>
                  <th scope="col" rowspan="2">Fielded Vs Goal</th>
                  <th scope="col" colspan="2" class="group-head">
                    Standard path
                  </th>
                  <th scope="col" colspan="2" class="group-head">
                    Midway path
                  </th>
                  <th scope="col" colspan="2" class="group-head">Stored now</th>
                </tr>
                <tr>
                  <th scope="col">Current Target</th>
                  <th scope="col">Currently Open</th>
                  <th scope="col">Current Target</th>
                  <th scope="col">Currently Open</th>
                  <th scope="col">Current Target</th>
                  <th scope="col">Currently Open</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of quotaComparison">
                  <td>{{ row.quotaTitle || row.quotaId }}</td>
                  <td class="value-cell">{{ row.percentage }}</td>
                  <td class="value-cell">
                    {{ row.achieved }} | {{ row.maximum }}
                  </td>

                  <td class="value-cell group-start">
                    {{ row.standard.target }}
                    <span
                      class="as-date"
                      *ngIf="row.standard.isFallbackToMaximum"
                    >
                      fallback to maximum
                    </span>
                  </td>
                  <td
                    class="value-cell"
                    [class.value-cell--idle]="row.standard.isIdle"
                  >
                    {{ row.standard.open }}
                  </td>

                  <td class="value-cell group-start">
                    {{ row.midway.target }}
                    <span
                      class="as-date"
                      *ngIf="row.midway.isFallbackToMaximum"
                    >
                      fallback to maximum
                    </span>
                  </td>
                  <td
                    class="value-cell"
                    [class.value-cell--idle]="row.midway.isIdle"
                  >
                    {{ row.midway.open }}
                  </td>

                  <td class="value-cell group-start">
                    <span
                      [ngClass]="row.activeMatches ? 'flag-on' : 'flag-off'"
                      >{{ row.storedTarget }}</span
                    >
                    <span class="as-date">
                      {{ row.activeMatches ? 'matches' : 'differs' }}
                    </span>
                  </td>
                  <td class="value-cell">{{ row.storedOpen }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="panel__foot">
            {{
              projectionMatchesStored
                ? copy.projectionMatches
                : copy.projectionDiffers
            }}
            {{ copy.quotaGroupNote }}
          </div>
        </ng-container>
      </div>

      <div
        class="banner banner--warn"
        *ngIf="currentSnapshot && !hasCompletesData"
      >
        <strong>Completes panel unavailable</strong>
        {{ copy.completesUnavailable }}
      </div>

      <div class="panel" *ngIf="currentSnapshot">
        <div class="panel__head">
          <h3>Pacing position</h3>
          <span class="panel__sub">{{
            surveyAfter ? 'After the update' : 'Before the update'
          }}</span>
        </div>

        <div class="tiles">
          <div class="tile">
            <div class="tile__key">Elapsed</div>
            <div class="tile__value">
              {{
                elapsedHoursNow === null
                  ? '-'
                  : (elapsedHoursNow | number : '1.0-2')
              }}
              <span class="tile__unit" *ngIf="elapsedHoursNow !== null">h</span>
            </div>
            <div class="tile__detail" [class.tile__detail--on]="!!surveyAfter">
              {{
                elapsedPercent === null
                  ? 'planned field time unknown'
                  : elapsedPercent + '% of planned field time'
              }}
            </div>
          </div>

          <div class="tile">
            <div class="tile__key">Fulfilled field time</div>
            <div class="tile__value">
              {{ currentSnapshot.fulfilledFieldTimeInPacingUnits ?? '-' }}
            </div>
            <div class="tile__detail">
              pacing units ({{ currentSnapshot.feot.pacing || 'n/a' }})
            </div>
          </div>

          <div class="tile">
            <div class="tile__key">Planned field time</div>
            <div class="tile__value">
              {{ currentSnapshot.plannedFieldTimeInPacingUnits }}
            </div>
            <div class="tile__detail">
              pacing units
              <ng-container *ngIf="currentSnapshot.fldTime">
                &middot; {{ currentSnapshot.fldTime }} days</ng-container
              >
            </div>
          </div>

          <div class="tile">
            <div class="tile__key">Queue</div>
            <div class="tile__value">
              {{ response ? (response.enqueued ? 'Enqueued' : 'Stored') : '-' }}
            </div>
            <div class="tile__detail">
              {{
                response
                  ? response.enqueued
                    ? 'pushed to the FEOT queue'
                    : 'dates stored, nothing pushed'
                  : 'no recalculation pushed yet'
              }}
            </div>
          </div>
        </div>

        <div class="field-window">
          <div class="field-window__legend">
            <span class="field-window__lead">Field window</span>
            <span *ngIf="surveyAfter"
              >hatched = before &middot; solid = after</span
            >
            <span class="field-window__readout">
              {{
                elapsedHoursNow === null
                  ? '-'
                  : (elapsedHoursNow | number : '1.0-2')
              }}
              / {{ plannedHours ?? '-' }} h
            </span>
          </div>

          <div class="bar">
            <div class="bar__before" [style.width.%]="beforeBarWidth"></div>
            <div class="bar__after" [style.width.%]="afterBarWidth"></div>
            <div class="bar__tick" style="left: 50%"></div>
            <div class="bar__tick" style="left: 90%"></div>
          </div>

          <div class="bar-scale">
            <span>launch</span>
            <span>mid 50%</span>
            <span>near-end 90%</span>
            <span>end</span>
          </div>
        </div>
      </div>

      <div
        class="banner banner--danger"
        *ngIf="surveyBefore && !surveyBefore.isSimulationTarget"
      >
        <strong>Update would be rejected</strong>
        {{ copy.notSimulable }}
      </div>

      <div
        class="banner banner--warn"
        *ngIf="response && !response.isMidwaySurvey"
      >
        <strong>Standard path - the clock will not move</strong>
        {{ copy.standardPathWarning }}
      </div>

      <div class="panel" *ngIf="hasSurveyState">
        <div class="panel__head">
          <h3>Survey state</h3>
          <span class="panel__sub">{{
            surveyAfter
              ? 'Before and after the update'
              : 'Before only - run an update to fill the After column'
          }}</span>
        </div>

        <p class="panel__note" *ngIf="surveyLoading">Reading the survey...</p>
        <p class="panel__note panel__note--error" *ngIf="surveyError">
          {{ surveyError }}
        </p>

        <ng-container
          *ngIf="surveyBefore"
          [ngTemplateOutlet]="snapshotTable"
          [ngTemplateOutletContext]="{ groups: snapshotGroups, grouped: true }"
        ></ng-container>

        <div class="panel__foot" *ngIf="surveyAfter">
          {{ copy.snapshotChanged }}
        </div>
      </div>
    </section>

    <!-- ============ lambda + payload ============ -->
    <section class="tool-column">
      <div class="panel" *ngIf="surveyBefore">
        <div class="panel__head">
          <h3>Written by the pacing lambda</h3>
        </div>

        <ng-container
          [ngTemplateOutlet]="snapshotTable"
          [ngTemplateOutletContext]="{ groups: lambdaGroups, grouped: false }"
        ></ng-container>

        <div class="panel__foot">{{ copy.lambdaRows }}</div>
      </div>

      <div class="panel">
        <div class="panel__head">
          <h3>Execution payload</h3>
          <span class="panel__sub" *ngIf="response"
            >PATCH response &middot; {{ response.env }}</span
          >
        </div>

        <p class="panel__empty" *ngIf="!response">{{ copy.noResponse }}</p>

        <div class="table-scroll" *ngIf="responseView as payload">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Field</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of responseRows">
                <td>{{ row.label }}</td>
                <ng-container
                  *ngTemplateOutlet="
                    valueCell;
                    context: { source: payload, row: row }
                  "
                ></ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</main>
